module.exports = __webpack_public_path__ + "img/cute-list.ac08cd23.svg";